export default [
    'trotz',
    'wegen',
    'anstatt',
    'während',
    'außerhalb',
    'innerhalb',
    'anstelle',
    'aufgrund'
];